import * as yup from 'yup';
import { propertyContractBaseSchema } from '@/features/Contract/Property/contractBaseSchema';
import { elementarSchema } from '@/features/Sparten/shared/schema/property/contract/elementarSchema';
import { insuredObjectBaseSchema } from '@/features/Sparten/shared/schema/property/contract/insuredObjectBaseSchema';
import {
  hasDoctorsOffice,
  hasGebaeudeImBau,
  hasOffice,
  hasOtherBusinesses,
  isCommercialUse,
} from '@/features/Sparten/woh/formConfigs/sharedRenderConditions';
import { propertyPreviousDamageSharedWithElementarAndGlas } from '@/features/Contract/Property/contractBaseSchemaWithElementarAndGlas';

const wohContractSchema = insuredObjectBaseSchema.concat(
  yup.object({
    elementargefahren: elementarSchema,
    vorschaden: propertyPreviousDamageSharedWithElementarAndGlas,
    trennungBrandmauer: yup.boolean().default(false),
    gewerblicheNutzung: yup.boolean().default(false),
    gewerbeGebaeude: yup.object({
      anzahlPraxen: yup
        .number()
        .default(null)
        .nullable()
        .when({
          is: () => isCommercialUse.value,
          then: () => yup.number().required(),
        }),
      flaechePraxen: yup
        .number()
        .default(null)
        .nullable()
        .when({
          is: () => hasDoctorsOffice.value,
          then: () => yup.number().required(),
        }),
      anzahlBueros: yup
        .number()
        .default(null)
        .nullable()
        .when({
          is: () => isCommercialUse.value,
          then: () => yup.number().required(),
        }),
      flaecheBueros: yup
        .number()
        .default(null)
        .nullable()
        .when({
          is: () => hasOffice.value,
          then: () => yup.number().required(),
        }),
      anzahlSonstigeGewerbe: yup
        .number()
        .default(null)
        .nullable()
        .when({
          is: () => isCommercialUse.value,
          then: () => yup.number().required(),
        }),
      flaecheSonstigeGewerbe: yup
        .number()
        .default(null)
        .nullable()
        .when({
          is: () => hasOtherBusinesses.value,
          then: () => yup.number().required(),
        }),
    }),
    denkmalschutz: yup.boolean().default(false),
    gebaeudeImBau: yup.boolean().default(false),
    rohbau: yup.object({
      baubeginn: yup
        .number()
        .default(null)
        .nullable()
        .when({
          is: () => hasGebaeudeImBau.value,
          then: yup.number().required(),
        }),
      bezug: yup
        .number()
        .default(null)
        .nullable()
        .when({
          is: () => hasGebaeudeImBau.value,
          then: yup.number().required(),
        }),
      feuerRohbauRisiko: yup.boolean().default(false),
    }),
    baumangel: yup.boolean().default(false),
  }),
);

export const contractSchema =
  propertyContractBaseSchema.concat(wohContractSchema);
